var render, staticRenderFns
import script from "./customer_account.vue?vue&type=script&lang=js"
export * from "./customer_account.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b28617f8')) {
      api.createRecord('b28617f8', component.options)
    } else {
      api.reload('b28617f8', component.options)
    }
    
  }
}
component.options.__file = "found/views/kms/views/customer_account/customer_account.vue"
export default component.exports